export enum OrigemDocumentoFiscalEmitidoEnum {
  EstruturaAntiga = 1,
  EstruturaNova = 2,
}
